import {
    CREATE_USER_FORM_PRODUCTION_REPORT,
    FETCH_PRODUCTION_REPORTS_DATA_FAILURE,
    FETCH_PRODUCTION_REPORTS_DATA_REQUEST,
    FETCH_PRODUCTION_REPORTS_DATA_SUCCESS,
    FETCH_PROGRAM_REPORTS_DATA_FAILURE,
    FETCH_PROGRAM_REPORTS_DATA_REQUEST,
    FETCH_PROGRAM_REPORTS_DATA_SUCCESS,
    SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT
} from "./productionReport.actionType";


export const PRODUCTION_REPORT = 'productionReport';

let initialState = {
    loading: false,
    productionReportData: [],
    productionWiseUserform: {
        fldFKUnitId: '',
        fldProgram: '',
        fldFKSubStyle: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date()
    },
    renderGridBtn: 'summaryGrid',
    programReport: []
};

export let productionReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCTION_REPORTS_DATA_REQUEST:
        case FETCH_PROGRAM_REPORTS_DATA_REQUEST:

            return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCTION_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productionReportData: updatePayload.YAI
            };
        case FETCH_PROGRAM_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                programReport: updatePayload.PRD
            }
        // case FETCH_COMPACTING_REPORTS_DATA_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         compactingMasterMainList: updatePayload
        //     };
        case FETCH_PRODUCTION_REPORTS_DATA_FAILURE:
        case FETCH_PROGRAM_REPORTS_DATA_FAILURE:

            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT:
            return {
                ...state,
                renderGridBtn: payload
            };

        case CREATE_USER_FORM_PRODUCTION_REPORT:
            return {
                ...state,
                loading: false,
                productionWiseUserform: {
                    ...state.productionWiseUserform,
                    [payload.key]: payload.value
                }
            }

        default:
            return state;
    }
};